
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzeEditorDialog extends Serenity.Extensions.GridEditorDialog<ProdottiEsperienzeRow> {
        protected getFormKey() { return ProdottiEsperienzeForm.formKey; }
        protected getIdProperty() { return ProdottiEsperienzeRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeRow.localTextPrefix; }

        protected form = new ProdottiEsperienzeForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // Questa gestisce l'editor.          
            this.form.EsperienzaClassiList.IdProdottoEsperienza = this.form.IdProdottoEsperienza.value;
            this.form.EsperienzaClassiList.idProdotto = this.idProdotto;

            // Questa gestisce l'editor.          
            // this.form.EsperienzaTaskList.IdProdottoEsperienza = this.form.IdProdottoEsperienza.value;
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //
            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            }

            return buttons;
        }

        validateBeforeSave() {
            var bReturn = super.validateBeforeSave();

            if (bReturn) {
                if (this.form.EsperienzaClassiList.getView().getItems().length == 0) {
                    Q.alert("La missione non è stata associata a nessuna classe!");
                    bReturn = true;
                }
            }

            return bReturn;
        }

        onDialogClose() {
            if (!this.isNewOrDeleted() && this.form.EsperienzaClassiList.getView().getItems().length == 0) {
                Q.warning("La missione non è stata associata a nessuna classe!");
            }
        }

        // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
        private _idProdotto: number;

        get idProdotto() {
            return this._idProdotto;
        }

        set idProdotto(value: number) {
            if (this._idProdotto != value) {
                this._idProdotto = value;
            }
        }
    }
}